// The preview canvas is stretched by CSS with object-fit: contain, so the painted frame can sit
// letterboxed inside the element box: in portrait the element is around 798px wide while the frame
// itself is only around 315px. Anything mapping between screen pixels and renderer pixels has to
// measure the painted rectangle, or every hit test and overlay lands offset by the bars.
export function measurePaintedFrame(canvas) {
    const bounds = canvas.getBoundingClientRect();
    const scale = Math.min(bounds.width / canvas.width, bounds.height / canvas.height);

    return {
        scale: scale,
        left: bounds.left + (bounds.width - canvas.width * scale) / 2,
        top: bounds.top + (bounds.height - canvas.height * scale) / 2
    };
}

// Client pixels have to be rescaled to the renderer's own pixel grid before anything can be
// compared against the PIXI display tree. Takes anything carrying clientX and clientY, so a pointer
// event can be handed over as it is.
export function toRendererCoordinates(canvas, clientPoint) {
    const frame = measurePaintedFrame(canvas);

    return {
        x: (clientPoint.clientX - frame.left) / frame.scale,
        y: (clientPoint.clientY - frame.top) / frame.scale
    };
}
